<template>
  <div class="animated fadeIn">
    <GeneralSpinner v-if="spinner_device"></GeneralSpinner>
    <div v-else="">
      <div class="tabs-select-style form-group row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <select id="select" name="select" class="form-control" @change="selectDevice()" v-model="selected_device">
            <option value="0" disabled>{{web_texts.selected_device_t}}</option>
            <option :value="device" v-for="device in devices" v-if="device.name!=='Irrimation' && device.type!=='CVMNET4' && device.type!=='LM4A'">{{device.name}}</option>
          </select>
        </div>
      </div>
    </div>
    <br>
    <div>
      <div v-if="device_type==='CVM'">
        <CvmAnalyzer :device_select="selected_device"></CvmAnalyzer>
      </div>
      <div v-else-if="device_type==='CVMMINI' || device_type==='CVMNET'">
        <LiteAnalyzer :device_select="selected_device"></LiteAnalyzer>
      </div>
      <div v-else-if="device_type==='NET4CH'">
        <Net4Analyzer :device_select="selected_device"></Net4Analyzer>
      </div>
      <div v-else-if="device_type==='CEMC6' || device_type==='CEMC30' || device_type==='CEMC20'">
        <EnergyAnalyzer :device_select="selected_device"></EnergyAnalyzer>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Device';
  import trans_es from '../translates/es/Device';
  import constants from '../constants';
  import middleware from '../utilities/middlewares';
  import CvmAnalyzer from './partials/device_partials/CvmAnalyzer.vue';
  import LiteAnalyzer from './partials/device_partials/LiteAnalyzer.vue';
  import Net4Analyzer from './partials/device_partials/Net4Analyzer.vue';
  import EnergyAnalyzer from "./partials/device_partials/EnergyAnalyzer";
  import GeneralSpinner from './partials/GeneralSpinner.vue';


  export default {
    name: 'Device',
    data () {
      return {
        web_texts: { "selected_device_t": "Seleccionar Dispositiu", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "api": "Pot. Actual", "current_tension": "Tensió actual", "api_now": "Potència Activa Instantània", "active_reactive": "Energia activa-reactiva", "ae": "Energia Activa", "ie": "Energia Reactiva", "cosi": "Cosinus de Phi Instantàni", "historical_active_power": "Històric potència activa", "historical_active_reactive_energy": "Històric energia activa-reactiva" } },
        system: '',
        spinner_device: true,
        devices: '',
        selected_device: 0,
        device_type: ''
      }
    },
    components:{
      CvmAnalyzer,
      LiteAnalyzer,
      Net4Analyzer,
      EnergyAnalyzer,
      GeneralSpinner
    },
    created () {
      middleware.userIsLoged();
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.system=JSON.parse(localStorage.getItem('system'));
      this.getSlaves();
    },
    methods: {
      // Llegir tots els dispositius
      getSlaves(){
        axios.post(constants.ROOT_URL + '/api/v1/get_devices', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.devices=response.data;
          for(var i=0; i<this.devices.length; i++){
            if(this.devices[i].type==="CVMNET4"){
              var channel=JSON.parse(this.devices[i].channels);
              for(var c=0; c<channel.length;c++){
                this.devices.push(channel[c])
              }
            }
          }
          this.spinner_device=false;
        }, (response) => {
          console.log(response);
        });
      },
      // Llegir el tipus de dispositiu del dispositiu seleccionat
      selectDevice(){
        var out=this;
        this.device_type='';
        setTimeout(function(){
          out.device_type=out.selected_device.type;
        }, 50);

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Device.vue?54b87e72